// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BETypeElement } from './BETypeElement';
import { BEComponent } from './BEComponent';
import { Implement } from './Implement';
import { InterfaceGeneration } from './InterfaceGeneration';
import { InterfaceAttribute } from './InterfaceAttribute';
import { InterfaceMethod } from './InterfaceMethod';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
import { BEInterfaceExtend } from '../../../../../../extension/com/MetaPattern/MDA/MD/EntityModel/BEInterfaceExtend';
/**
 * 接口 实体类
 * 接口类型
 */
export class BEInterface extends BETypeElement {
  /** 组件 的ID */
  private _component_ID: string;

  /** 获取：组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 组件  */
  private _component: BEComponent;

  /** 获取：组件  */
  public get component() {
    return this._component;
  }

  /** 设置：组件  */
  public set component(value: BEComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  /** 实现关系集合 */
  private _implements: Array<Implement>;

  /** 获取：实现关系集合 */
  public get implements() {
    return this._implements;
  }

  /** 设置：实现关系集合 */
  public set implements(value: Array<Implement>) {
    this._implements = value;
  }

  /** 接口继承关系集合（当前为父接口） */
  private _superGenerations: Array<InterfaceGeneration>;

  /** 获取：接口继承关系集合（当前为父接口） */
  public get superGenerations() {
    return this._superGenerations;
  }

  /** 设置：接口继承关系集合（当前为父接口） */
  public set superGenerations(value: Array<InterfaceGeneration>) {
    this._superGenerations = value;
  }

  /** 接口继承关系集合（当前为子接口） */
  private _subGenerations: Array<InterfaceGeneration>;

  /** 获取：接口继承关系集合（当前为子接口） */
  public get subGenerations() {
    return this._subGenerations;
  }

  /** 设置：接口继承关系集合（当前为子接口） */
  public set subGenerations(value: Array<InterfaceGeneration>) {
    this._subGenerations = value;
  }

  /** 属性 */
  private _attributes: Array<InterfaceAttribute>;

  /** 获取：属性 */
  public get attributes() {
    return this._attributes;
  }

  /** 设置：属性 */
  public set attributes(value: Array<InterfaceAttribute>) {
    this._attributes = value;
  }

  /** 方法 */
  private _methods: Array<InterfaceMethod>;

  /** 获取：方法 */
  public get methods() {
    return this._methods;
  }

  /** 设置：方法 */
  public set methods(value: Array<InterfaceMethod>) {
    this._methods = value;
  }

  constructor() {
    super();
    BEInterfaceExtend.Init(this);
    this._component_ID = '';
    this._component = null;
    this._implements = new Array<Implement>();
    this._superGenerations = new Array<InterfaceGeneration>();
    this._subGenerations = new Array<InterfaceGeneration>();
    this._attributes = new Array<InterfaceAttribute>();
    this._methods = new Array<InterfaceMethod>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: BEInterface, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = BEComponent.Create(json.Component);
    // }
    if (json.Implements && json.Implements.length > 0) {
      json.Implements.forEach((element: any) => {
        const implement = Implement.Create(element);
        // implement.interface = this;
        this.implements.push(implement);
      });
    }
    if (json.SuperGenerations && json.SuperGenerations.length > 0) {
      json.SuperGenerations.forEach((element: any) => {
        const interfaceGeneration = InterfaceGeneration.Create(element);
        // interfaceGeneration.superInterface = this;
        this.superGenerations.push(interfaceGeneration);
      });
    }
    if (json.SubGenerations && json.SubGenerations.length > 0) {
      json.SubGenerations.forEach((element: any) => {
        const interfaceGeneration = InterfaceGeneration.Create(element);
        // interfaceGeneration.subInterface = this;
        this.subGenerations.push(interfaceGeneration);
      });
    }
    if (json.Attributes && json.Attributes.length > 0) {
      json.Attributes.forEach((element: any) => {
        const interfaceAttribute = InterfaceAttribute.Create(element);
        // interfaceAttribute.interface = this;
        this.attributes.push(interfaceAttribute);
      });
    }
    if (json.Methods && json.Methods.length > 0) {
      json.Methods.forEach((element: any) => {
        const interfaceMethod = InterfaceMethod.Create(element);
        // interfaceMethod.interface = this;
        this.methods.push(interfaceMethod);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Component_ID = this.component_ID;
    if (this.implements && this.implements.length > 0) {
      json.Implements = [];
      this.implements.forEach((element) => {
        json.Implements.push(element.toJson());
      });
    }
    if (this.superGenerations && this.superGenerations.length > 0) {
      json.SuperGenerations = [];
      this.superGenerations.forEach((element) => {
        json.SuperGenerations.push(element.toJson());
      });
    }
    if (this.subGenerations && this.subGenerations.length > 0) {
      json.SubGenerations = [];
      this.subGenerations.forEach((element) => {
        json.SubGenerations.push(element.toJson());
      });
    }
    if (this.attributes && this.attributes.length > 0) {
      json.Attributes = [];
      this.attributes.forEach((element) => {
        json.Attributes.push(element.toJson());
      });
    }
    if (this.methods && this.methods.length > 0) {
      json.Methods = [];
      this.methods.forEach((element) => {
        json.Methods.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    return context;
  }

  static Create(json: any): BEInterface {
    const bEInterface = new BEInterface();
    bEInterface.Deserialize(json);
    bEInterface.json = json;
    return bEInterface;
  }
}
